import { When } from '@/components';
import type { AssignmentHistoryItem } from '@uchat-team-management/shared';
import { For, Show } from 'solid-js';

export const AssignmentHistory = (props: { history: readonly AssignmentHistoryItem[] }) => (
  <section class="rounded-xl border border-neutral-100 bg-surface p-4 shadow-sm dark:border-neutral-800 dark:bg-surface-dark">
    <h2 class="mb-3 text-base font-semibold">History (last 10)</h2>
    <Show
      when={props.history.length > 0}
      fallback={<p class="text-sm text-neutral-500">No assignment history yet.</p>}
    >
      <ul class="flex flex-col text-sm">
        <For each={props.history}>
          {(h) => (
            <li class="-mx-2 rounded-lg px-2 py-1.5 transition-colors duration-200 ease-out hover:bg-neutral-50 motion-reduce:transition-none dark:hover:bg-neutral-800/50">
              <p class="break-words font-medium">{h.userDisplayName || h.userEmail}</p>
              <Show when={h.note}>
                <p class="break-words text-neutral-500">{h.note}</p>
              </Show>
              <p class="text-xs text-neutral-500">
                <When date={h.assignedAt} class="" />
                <Show when={h.unassignedAt} fallback=" — active">
                  {(until) => (
                    <>
                      {' → '}
                      <When date={until()} class="" />
                    </>
                  )}
                </Show>
              </p>
            </li>
          )}
        </For>
      </ul>
    </Show>
  </section>
);
